import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logoImg from "../../../assets/images/branding/logo-torneiofacil.png";
import Button from "../../../components/atoms/button";
import Input from "../../../components/atoms/input";
import useAuthenticate from "../../../hooks/useAuthenticate";

import Navbar from "../../../components/organisms/navbar";
import api from "../../../services/api";
import {
  AccountExists,
  Container,
  Content,
  FormContent,
  FormGroup,
  PageDescription,
  PageLogo,
  PageTitle,
  PasswordRecovery,
  SectionBanner,
  SectionForm,
} from "./styles";
import Swal from "sweetalert2";
import { Box, CircularProgress, Typography } from "@mui/material";

const Login: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { setToken } = useAuthenticate();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data: any) => {
    setLoading(true);

    api
      .post("/auth/login", {
        ...data,
      })
      .then((response) => {
        setLoading(false);
        toast.success(response.data.message);

        Swal.fire({
          title: "Sucesso!",
          text: `${response.data.message}`,
          icon: "success",
        });

        setToken(response.data.accessToken);

        setTimeout(() => {
          navigate("/profile");
        }, 2000);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Swal.fire({
          title: "Atenção",
          text: `${error.response.data.message}`,
          icon: "warning",
          showCloseButton: true,
          confirmButtonColor: "var(--navy)",
        });
      });
  };

  return (
    <>
    <Navbar />
    <Container>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            zIndex: 2000,
            gap: 2,
          }}
        >
          <Typography
            sx={{ fontFamily: "var(--font-body)", fontSize: "1.1rem", color: "var(--navy)" }}
          >
            Aguarde, estamos realizando seu login...
          </Typography>

          <CircularProgress sx={{ color: "var(--navy)" }} />
        </Box>
      )}

      <SectionForm>
        <Content>
          <Link to={"/"}>
            <PageLogo src={logoImg} />
          </Link>
          <PageTitle>Entrar</PageTitle>
          <PageDescription>
            Bem-vindo ao Torneio Fácil, acesse sua conta preenchendo os dados
            abaixo.
          </PageDescription>

          <FormContent onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <Input
                label="E-mail"
                name="email"
                type="text"
                register={register}
                required
                hasError={!!errors.email}
                error="Este campo é obrigatório"
                transformToLowerCase={true}
                trim={true}
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="Senha"
                name="password"
                type="password"
                register={register}
                required
                hasError={!!errors.password}
                error="Este campo é obrigatório"
                trim={true}
              />
            </FormGroup>
            <FormGroup>
              <PasswordRecovery href="/password-recovery">
                Esqueceu a sua senha? <strong>Recupere aqui.</strong>
              </PasswordRecovery>
            </FormGroup>
            <FormGroup>
              <Button type="submit" label="Entrar" />
            </FormGroup>
            <FormGroup>
              <AccountExists href="/register">
                Ainda não possui conta? Cadastre-se aqui
              </AccountExists>
            </FormGroup>
          </FormContent>
        </Content>
      </SectionForm>
      <SectionBanner></SectionBanner>
    </Container>
    </>
  );
};

export default Login;
